import { render, staticRenderFns } from "./starryGLHeader.vue?vue&type=template&id=cca4b812&scoped=true&"
import script from "./starryGLHeader.vue?vue&type=script&lang=js&"
export * from "./starryGLHeader.vue?vue&type=script&lang=js&"
import style0 from "./starryGLHeader.vue?vue&type=style&index=0&id=cca4b812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca4b812",
  null
  
)

export default component.exports